import Navbar from "../../Components/Navbar/index";
import Footer from "../../Components/Footer/index";
import LoginComponent from "../../Components/Login/index";
import DocumentMeta from "react-document-meta";
import React from "react";



const Login = () => {
    const meta = {
        title: 'Se connecter - Vignitus',
        description: 'La page pour vous connecter à votre espace personnel.',
        canonical: 'https://vignitus.fr/login',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Vignitus, Connexion'
            }
        }
    };
    return (
        <DocumentMeta {...meta}>
            <div>
                <Navbar />
                <div className="content-wraper">
                    <LoginComponent/>
                </div>
                <Footer />
            </div>
        </DocumentMeta>
    );
};

export default Login;